// import { Button, Snackbar } from "@material-ui/core";
import { Button, Snackbar } from "@material-ui/core";
import React, { useState } from "react";

interface Props {
  name: string;
  value: string;
}

const CopyToClipboardButton = (props: Props) => {
  const { name, value } = props;
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
    navigator.clipboard.writeText(value.toString());
  };

  return (
    <div>
      <Button fullWidth onClick={handleClick} variant="contained" color="secondary">
        {name}
      </Button>
      <Snackbar
        open={open}
        onClose={() => setOpen(false)}
        autoHideDuration={2000}
        message={`Copied ${name} to clipboard`}
      />
    </div>
  );
};

export default CopyToClipboardButton;
